import type { CustomIconProps } from '../types';

const Video = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
        width={width ?? '24'}
        height={height ?? '24'}
        viewBox="0 0 24 24"
    >
        <path d="M23.1 3.28a2.18 2.18 0 00-1.63-.72H2.53a2.18 2.18 0 00-1.63.72 2.29 2.29 0 00-.7 1.66v14.12a2.29 2.29 0 00.7 1.66 2.18 2.18 0 001.63.72h18.94a2.18 2.18 0 001.63-.72 2.29 2.29 0 00.7-1.66V4.94a2.29 2.29 0 00-.7-1.66zM8.46 16.93V7.4l9.44 4.81z" />
        <g>
            <path d="M23.1 3.28a2.18 2.18 0 00-1.63-.72H2.53a2.18 2.18 0 00-1.63.72 2.29 2.29 0 00-.7 1.66v14.12a2.29 2.29 0 00.7 1.66 2.18 2.18 0 001.63.72h18.94a2.18 2.18 0 001.63-.72 2.29 2.29 0 00.7-1.66V4.94a2.29 2.29 0 00-.7-1.66zM8.46 16.93V7.4l9.44 4.81z" />
        </g>
    </svg>
);

export default Video;
